<template>
  <div>
    <v-card-title class="pa-0 mb-1">
      <span class="title no-truncate">{{ step.title }}</span>
    </v-card-title>
    <v-card-text class="pa-0">
      <span
        class="text py-2 mb-1"
        v-if="step.content"
        >{{ step.content }}</span
      >
      <slot
        name="content"
        class="mb-1"
      />
      <slot
        name="actions"
        class="mb-1"
      />
    </v-card-text>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

import { Step as StepInterface } from '@/modules/landingpage/models/Step'
defineProps({
  step: {
    type: Object as PropType<StepInterface>,
    required: true,
  },
})
</script>

<style scoped>
.title {
  color: white;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}

.text {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.no-truncate {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.step-card-desktop .title,
.step-card-desktop .text {
  color: black;
}
</style>
